import { App, Plugin } from "vue";

const plugin: Plugin = {
  install: (app: App) => {
    app.directive("tooltip", {
      mounted(el, binding) {
        el.classList.add("tooltip", `tooltip--${binding.arg || "top"}`);
        el.setAttribute("data-tooltip", binding.value.toString());
      },
      updated(el, binding) {
        el.setAttribute("data-tooltip", binding.value.toString());
      },
    });
  },
};

export default plugin;
